<!-- smeltingEquipment -->
<template>
  <div class="smeltingEquipment">
    <div class="bgBox section1 ">
      <div class="s1_innerBox typeArea">
        <div class="opctBox">
          <div class="p1">
            In the field of levitation metallurgy, 
SUMMIT's technology has reached the 
international advanced level
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="bgBox section2 " id="设备简介">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="top">
            <div class="box1">
              <div class="topTitle leftTop">
                <div class="p1">
                  <span>ABOUT </span>EQUIPMENT
                </div>
                <div class="p2"></div>
                <div class="p4">
                  The core part of the levitation melting equipment system is the cold crucible induction levitation melting technology.
                </div>
                <div class="p5">
                  The technology involves placing a segmented water-cooled crucible inside an alternating electromagnetic field, utilizing the eddy current generated by the electromagnetic field to heat the molten metal, and relying on electromagnetic force to maintain soft or non-contact contact between the molten metal and the crucible wall, thereby achieving material melting.
                </div>
                <div class="p5">
                  Its most important feature is that the melted material is in a levitated or quasi levitated state, which can solve the defects of non-uniformity and secondary pollution in current material production processes.
                </div>
              </div>
            </div>
            <div class="box2">
              <img src="../../static/images/smeltingEquipment/设备简介.jpg" alt="">
            </div>
          </div>
          <div class="text">
            SUMMIT has successfully developed series of key technologies such as enhancing suspension force, increasing melting temperature, extending crucible life, expanding equipment specifications, improving operating efficiency, improving alloy uniformity, and automatic control operating systems.
          </div>
          <div class="bottom">
            <div class="item">Uniform composition</div>
            <div class="item">High purity</div>
            <div class="item">High melting temperature</div>
            <div class="item">Wide range of melting weights</div>
            <div class="item">Strong levitation ability</div>
            <div class="item">Various of casting process</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3 " id="设备组成">
      <div class="s3_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>EQUIPMENT </span>PARTS
          </div>
          <div class="p2"></div>
        </div>
        <div class="bodyBox">
          <div class="item">
            <div class="p1">Furnace</div>
          </div>
          <div class="item">
            <div class="p1">Power supply system</div>
          </div>
          <div class="item">
            <div class="p1">Intelligent operating system</div>
          </div>
          <div class="item">
            <div class="p1">Automatic control system</div>
          </div>
          <div class="item">
            <div class="p1">Water cooling system</div>
          </div>
          <div class="item">
            <div class="p1">Vacuum system</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section4 " id="领先技术">
      <div class="s4_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>LEADING </span>TECHNOLOGY
          </div>
          <div class="p2"></div>
        </div>
        <div class="box1">
          <div class="item">
            <img src="../../static/images/smeltingEquipment/悬浮能力强.png" alt="">
            <div class="p1">
              Strong levitation ability
            </div>
            <div class="p2"></div>
            <div class="p3">The height/diameter ratio of the hump of the melting pool is 2.0~3.0, and there is little condensation in the melting process</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/熔炼温度高.png" alt="">
            <div class="p1">
              High melting temperature
            </div>
            <div class="p2"></div>
            <div class="p3">The maximum melting temperature can reach 3600℃, which can melt tungsten, tantalum, molybdenum, niobium and other refractory metals</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/规格范围广.png" alt="">
            <div class="p1">
              Wide range of specifications
            </div>
            <div class="p2"></div>
            <div class="p3">Smelting capacity from 50g to 200kg specification series</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/数字化.png" alt="">
            <div class="p1">
              Digital display
            </div>
            <div class="p2"></div>
            <div class="p3">The parameters of each system of the equipment are displayed on the screen in real time, which is convenient for the operator to view</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/智能化.png" alt="">
            <div class="p1">
              Intelligent operation
            </div>
            <div class="p2"></div>
            <div class="p3">The equipment can be started and stopped with one key, and the system can be associated with the control operator to operate quickly and intelligently</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/现代化技术.png" alt="">
            <div class="p1">
              Combine  modern technologies
            </div>
            <div class="p2"></div>
            <div class="p3">Centrifugal casting, bottom casting, suction casting, continuous drawing ingot, arc melting, plasma melting, etc</div>
          </div>
        </div>
        <div class="box2">
          <div class="label">Continuous improvements in technology (melting most metals of the periodic table)</div>
          <img src="../../static/images/smeltingEquipment/折线图-PC英文.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="bgBox section5" id="设备应用">
      <div class="s5_innerBox typeArea">
        <div class="topTitle leftTop">
          <div class="p1">
            <span>EQUIPMENT </span>APPLICATION
          </div>
          <div class="p2"></div>
          <div class="img">

          </div>
          <!-- <img src="../../static/images/smeltingEquipment/设备应用.jpg" alt=""> -->
        </div>
        <div class="carBox">
          <el-carousel indicator-position="outside" :interval="3000">
            <el-carousel-item :key="1" class="key1">
              <div class="left">
                <img src="../../static/images/smeltingEquipment/通用型设备.jpg" alt="">
                <div class="fixBox">The equipment is used to melt special alloys</div>
              </div>
              <div class="right">
                <div class="topBox">
                  <div class="p1">
                    Superalloys, shape memory alloys, low melting point metals and alloys
                  </div>
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/高温1.jpg" alt="">
                    </div>
                    <div class="item"><img src="../../static/images/smeltingEquipment/高温2.jpg" alt=""></div>
                  </div>
                </div>
                <div class="bottomBox">
                  <div class="p1">
                    High entropy alloy, bulk amorphous alloy
                  </div>
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/高3.jpg" alt="">
                    </div>
                    <div class="item"><img src="../../static/images/smeltingEquipment/高4.jpg" alt=""></div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="2" class="key2">
              <div class="left">
                <img src="../../static/images/smeltingEquipment/专用型.jpg" alt="">
                <div class="fixBox">The equipment is used to extract precious metals</div>
              </div>
              <div class="right">
                <div class="topBox">
                  <div class="p1">
                    Extraction of high value-added rare precious metals from tailings
                  </div>
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/1.jpg" alt="">
                    </div>
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/2.jpg" alt="">
                    </div>
                  </div>
                </div>
                <div class="bottomBox">
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/3.jpg" alt="">
                    </div>
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/4.jpg" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="3" class="key3">
              <div class="left">
                <img src="../../static/images/smeltingEquipment/悬浮型.jpg" alt="">
                <div class="fixBox">Equipment for melting sputtering targets (vacuum coating materials)</div>
              </div>
              <div class="right">
                <div class="topBox">
                  <div class="p1">
                    Semiconductor high-purity sputtering target, aerospace alloy sputtering target
                  </div>
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/悬浮1.jpg" alt="">
                    </div>
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/悬浮2.jpg" alt="">
                    </div>
                  </div>
                </div>
                <div class="bottomBox">
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/悬浮3.jpg" alt="">
                    </div>
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/悬浮4.jpg" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="4" class="key4">
              <div class="left">
                <img src="../../static/images/smeltingEquipment/MINI型.jpg" alt="">
                <div class="fixBox">Equipment Laboratory instruments used in research institutes</div>
              </div>
              <div class="right">
                <div class="topBox">
                  <div class="p1">
                    Basic material test equipment of universities and scientific research institutes
                  </div>
                  <div class="p3">
                    <div class="left">
                      <img src="../../static/images/smeltingEquipment/型1.jpg" alt="">
                    </div>
                    <div class="right">
                      <div class="item">
                        <img src="../../static/images/smeltingEquipment/型2.jpg" alt="">
                      </div>
                      <div class="item">
                        <img src="../../static/images/smeltingEquipment/型3.jpg" alt="">
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="bgBox section6" id="设备规格">
      <div class="s6_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>EQUIPMENT </span>SPECIFICATION
          </div>
          <div class="p2"></div>
          <div class="p4">
            Users can customize special specifications according to requirements, vacuum degree, control mode can be designed according to user requirements, 
          </div>
          <div class="p4">
            casting mode default casting, can be equipped with bottom casting, centrifugal casting, continuous drawing, feeder and other additional devices
          </div>
        </div>
        <div class="tableBox">
          <table width="100%" height="100%">
            <tbody>
              <tr>
                <th width="86px" class="redtd">Type</th>
                <th width="223px">Model number</th>
                <th width="240px">Smelting capacity Fe/Ti (kg)</th>
                <th width="240px">Ultimate vacuum (Pa)</th>
                <th width="196px">Melting temperature (℃)</th>
                <th>Control mode</th>
              </tr>
              <tr>
                <td rowspan="2" class="redtd">Minitype</td>
                <td>SMTX-XF-0.05</td>
                <td>0.05/0.03</td>
                <td rowspan="15">
                  <div class="div">Can be customized according to the actual requirements of users:</div>
                  <div>*** × 10<sup>-2</sup></div>
                  <div>*** × 10<sup>-3</sup></div>
                  <div>*** × 10<sup>-4</sup></div>
                </td>
                <td rowspan="15">≤3400℃</td>
                <td rowspan="15" style="text-align: left;"> 
                  <div>PLC+ touch screen or</div>
                  <div>PLC+ Industrial computer</div>
                  <div>Program control can be </div>
                  <div>realizedThere's water </div>
                  <div>pressure,Gas overpressure </div>
                  <div>and power outage </div>
                  <div>Protection </div>
                </td>
              </tr>
              <tr>
                <td>SMTX-XF-0.1</td>
                <td>0.1/0.06</td>
              </tr>
              <tr>
                <td rowspan="5" class="redtd">Minor</td>
                <td>SMTX-XF-0.3</td>
                <td>0.3/0.16</td>
              </tr>
              <tr>
                <td>SMTX-XF-0.5</td>
                <td>0.5/0.3</td>
              </tr>
              <tr>
                <td>SMTX-XF-1</td>
                <td>1.0/0.6</td>
              </tr>
              <tr>
                <td>SMTX-XF-2</td>
                <td>2.0/1.2</td>
              </tr>
              <tr>
                <td>SMTX-XF-3</td>
                <td>3.0/1.8</td>
              </tr>
              <tr>
                <td rowspan="3" class="redtd">Medium</td>
                <td>SMTX-XF-5</td>
                <td>5.0/3.0</td>
              </tr>
              <tr>
                <td>SMTX-XF-6</td>
                <td>6.0/3.6</td>
              </tr>
              <tr>
                <td>SMTX-XF-10</td>
                <td>10/6.0</td>
              </tr>
              <tr>
                <td rowspan="5" class="redtd">Large</td>
                <td>SMTX-XF-20</td>
                <td>20/12</td>
              </tr>
              <tr>
                <td>SMTX-XF-25</td>
                <td>25/15</td>
              </tr>
              <tr>
                <td>SMTX-XF-50</td>
                <td>50/30</td>
              </tr>
              <tr>
                <td>SMTX-XF-100</td>
                <td>100/60</td>
              </tr>
              <tr>
                <td>SMTX-XF-200</td>
                <td>200/120</td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>
    </div>
    <div class="bgBox section7" id="客户案例">
      <div class="s7_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>CLIENT </span>CASES
          </div>
          <div class="p2"></div>
        </div>
        <div class="itemBox">
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例1.jpg" alt="">
            <div class="label">100kg oxidation furnace installed in a research
institute in Baotou</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例2.jpg" alt="">
            <div class="label">100kg levitation furnace (double furnace) 
installed in a high-tech enterprise in Chengdu</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例3.jpg" alt="">
            <div class="label">50kg levitation furnace installed in a metal 
Research Institute in Beijing</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例4.jpg" alt="">
            <div class="label">50kg levitation furnace installed in a high-tech 
enterprise in Shizuishan</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例5.jpg" alt="">
            <div class="label">50kg levitation furnace installed in a 
high-tech enterprise in Qingyuan</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例7.jpg" alt="">
            <div class="label">50kg levitation furnace installed in an 
enterprise in Shandong</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例8.jpg" alt="">
            <div class="label">30kg levitation furnace installed in an 
enterprise in Shenyang</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例9.jpg" alt="">
            <div class="label">30kg levitation furnace installed in a metal
research institute in Xi 'an</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例6.jpg" alt="">
            <div class="label">20kg levitation furnace installed in a national 
defense research institute</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'smeltingEquipment',
    components: {},
    data() {
      return {

      }
    },
    computed: {},
    watch: {},
    created() {
      this.init()
      
    },
    mounted() {
      if(this.$store.state.pageId){
        this.$el.querySelector(this.$store.state.pageId).scrollIntoView({
          behavior:'smooth',
          block: "start"
        })
      }else{
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      this.$store.commit('savePageId','')
    },
    methods: {
      init() {

      },
    },
  }

</script>

<style lang='less' scoped>
  .smeltingEquipment {
    width: 100%;
    min-width: 1200px;


    .section1 {
      width: 100%;
      height: 600px;
      background: url('../../static/images/smeltingEquipment/banner.jpg') no-repeat;
      background-position: center;

      .s1_innerBox {
        text-align: left;
        height: 100%;
        height: 100%;
        
          padding-top: 174px;
        .opctBox {
          width: 1245px;
          height: 390px;
          // opacity: 0.4;
          background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 2%, rgba(0, 0, 0, 0.4) 20%, rgba(0, 0, 0, 0.4) 80%, rgba(255, 255, 255, 0.1) 98%, rgba(255, 255, 255, 0) 100%);
          .p1 {
            font-size: 60px;
            line-height: 100px;
            padding-top: 23px;
            color: #fefefe;
          }

          .line {
            width: 200px;
            height: 8px;
            margin-top: 15px;
            background-color: #c30000;
          }
        }

      }
    }

    .section2 {
      width: 100%;
      // height: 762px;

      .s2_innerBox {
        height: 100%;
        padding-top: 218px;
        width:1288px;
        .bodyBox {
          width: 100%;
          height: 710px;
          padding: 0 35px 20px 35px;
          background-color: #ffffff;
          border: solid 2px #f2f2f2;

          .top {
            display: flex;
            height: 420px;

            .box1 {
              flex: 1;

              .topTitle {
                .p1 {
                  margin-top: 35px;
                }

                .p2 {
                  margin-bottom: 45px;
                }

                .p4,
                .p5 {
                  font-size: 16px;
                  line-height: 28px;
                  color: #545454;
                  // text-indent: 2em;
                  padding-right: 10px;
                  font-weight: 400;
                }
              }
            }

            .box2 {
              width: 622px;
              height: 385px;
              position: relative;

              img {
                position: absolute;
                top: -53px;
                right: 0;
              }
            }
          }
          .text{
            font-size: 16px;
                  line-height: 28px;
                  color: #545454;
                  // text-indent: 2em;
                  padding-right: 10px;
                  font-weight: 400;
                  text-align: left;
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 48px;
            .item {
              width: 350px;
              height: 44px;
              line-height: 40px;
              text-align: center;
              border: solid 2px #c30000;
              font-size: 24px;
              color: #c30000;
              margin-bottom: 50px;
            }
          }
        }
      }
    }

    .section3 {
      width: 100%;
      height: 568px;

      .s3_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 178px;
          }
        }

        .bodyBox {
          margin-top: 50px;
          width: 100%;
          height: 420px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .item {
            width: 394px;
            height: 200px;
            background-color: #f2f2f2;
            display: flex;
            flex-direction: column;
            align-items: center;

            .p1 {
              width: 250px;
              height: 89px;
              line-height: 36px;
              background-color: #c30000;
              font-size: 20px;
              color: #fefefe;
              margin-top: 56px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .p2 {
              font-size: 16px;
              line-height: 16px;
              color: #555555;
              font-weight: 400;
              margin-top: 22px;
            }
          }
        }
      }
    }

    .section4 {
      width: 100%;
      height: 1969px;
      margin-top: 176px;
      background-color: #fbfbfb;

      .s4_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 176px;
          }
        }

        .box1 {
          width: 100%;
          height: 800px;
          margin-top: 99px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .item {
            width: 320px;
            height: 410px;
            padding: 0 25px;
            display: flex;
            flex-direction: column;
            align-items: center;

            img {}

            .p1 {
              font-size: 18px;
              line-height: 18px;
              color: #333333;
              font-weight: 700;
              margin-top: 45px;

              span {
                color: #c30000;
              }
            }

            .p2 {
              width: 50px;
              height: 4px;
              background-color: #c30000;
              margin: 20px 0 10px 0;
            }

            .p3 {
              color: #545454;
              font-size: 16px;
              line-height: 30px;
            }
          }
        }

        .box2 {
          display: flex;
          flex-direction: column;
          align-items: center;

          .label {
            height: 44px;
            line-height: 44px;
            background-color: #c30000;
            padding: 0 18px;
            font-size: 20px;
            color: #ffffff;
            margin-top: 120px;
            margin-bottom: 55px;
          }
        }
      }
    }

    .section5 {
      width: 100%;
      height: 1149px;
      background-color: #fbfbfb;

      .s5_innerBox {
        position: relative;
        height: 100%;
        padding-top: 226px;
        .topTitle {
          margin-bottom: 183px;
          position: relative;
          .p1 {
            margin-top: 0;
          }

          .img {
            position: absolute;
            top: -64px;
            left: 500px;
            height: 200px;
            width: calc(~"100vw/2 + 90px");
            background: url('../../static/images/smeltingEquipment/设备应用.jpg') no-repeat;
            background-position: left;
          }
        }

        .carBox {
          /deep/ .el-carousel {
            .el-carousel__container {
              height: 425px;

              .el-carousel__arrow {
                display: none;
              }

              .el-carousel__item {
                display: flex;
                justify-content: space-between;

                .left {
                  width: 578px;
                  height: 100%;
                  position: relative;

                  img {
                    height: 100%;
                  }

                  .fixBox {
                    height: 40px;
                    width: 100%;
                    background-color: #c30000;
                    line-height: 40px;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 400;
                    color: #ffffff;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                  }
                }

                .right {
                  width: 600px;
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;

                  .p1 {
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 18px;
                    color: #ffffff;
                    background-color: #c30000;
                    width: 100%;
                    font-weight: 400;
                    margin-bottom: 7px;
                  }

                  .topBox,
                  .bottomBox {
                    height: 202px;
                    width: 100%;

                    .p2 {
                      display: flex;
                      height: 155px;
                      width: 100%;
                      justify-content: space-between;

                      .item {
                        height: 100%;
                        width: 284px;
                      }
                    }
                  }

                  .bottomBox {
                    height: 198px;

                    .p2 {
                      height: 151px;
                    }
                  }

                }
              }

              .key2,
              .key3 {
                .topBox {
                  height: 225px !important;
                }

                .bottomBox {
                  height: 178px !important;
                }

                .item {
                  height: 178px !important;
                }
              }

              .key4 {
                .topBox {
                  height: 100% !important;
                }

                .p3 {
                  height: 378px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;

                  .left {
                    height: 100%;
                    width: 284px;
                  }

                  .right {
                    width: 284px;
                    height: 100%;

                    .item {
                      height: 178px;
                    }
                  }
                }
              }
            }

            .el-carousel__indicators {
              margin-top: 20px;

              .el-carousel__button {
                width: 30px;
                height: 6px;
                background-color: #cccccc;
              }

              .is-active {
                .el-carousel__button {
                  width: 50px;
                  height: 6px;
                  background-color: #c30000;
                }
              }
            }
          }
        }
      }
    }

    .section6 {
      padding-top: 107px;
      width: 100%;
      height: 1210px;

      .s6_innerBox {
        position: relative;
        height: 100%;

        .topTitle {
          // margin-bottom: 183px;

          .p1 {
            margin-top: 0;
          }

          .p4 {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
            line-height: 30px;
          }
        }

        .tableBox {
          width: 100%;
          height: 860px;
          margin-top: 60px;
          font-weight: 400;

          table {
            border-collapse: collapse;
          }

          .redtd {
            background-color: #c30000;
            color: #fefefe;
            font-size: 18px;

          }

          th.redtd {
            font-size: 16px;
          }

          tr {
            border: 1px solid #cccccc;
          }

          td,
          th {
            border: 1px solid #cccccc;
            font-size: 16px;
          }

          th {
            font-weight: normal;
            color: #333333;
            height: 44px;
          }

          td {
            font-weight: 400;
            color: #545454;
            padding: 0 10px;
          }
        }
      }
    }

    .section7 {
      padding-top: 260px;
      width: 100%;
      padding-bottom: 60px;
      // height: 1600px;

      .s7_innerBox {
        position: relative;
        height: 100%;

        .topTitle {
          // margin-bottom: 183px;

          .p1 {
            margin-top: 0;
          }


        }

        .itemBox {
          margin-top: 48px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          // height: 1072px;
          width: 100%;

          .item {
            width: 393px;
            height: 507px;
            margin-bottom: 60px;
            position: relative;

            img {
              width: 100%;
              height: 447px;
            }

            .label {
              height: 60px;
              line-height: 30px;
              text-align: center;
              width: 100%;
              background-color: #f8f8f8;
              position: absolute;
              left: 0;
              bottom: 0;
              font-size: 16px;
              color: #545454;
              font-weight: 400;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/smeltingEquipmentEn.vue